module.exports = __webpack_public_path__ + "static/media/chest-row.60ce295b.png";